import React, { Component } from 'react';
import { Modal, Alert } from 'react-bootstrap';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import orderBy from 'lodash/orderBy';
import {getServicesList, setDefaultService} from '../../actions/outgoingService';
import {getAgentInfo} from '../../actions/getAgentConfig';
import Loader from '../Components/Loader';
// import {modifyAgentInfo} from '../../actions/getAgentConfig';
import classnames from 'classnames';
import { logData } from '../../utils/utils';
import "../../agent/Styles/darktheme.css";
import "../../agent/Styles/blacktheme.css";
import "../../agent/Styles/highContrast.css";

class ChangeOutgoingService extends Component {

  constructor(props) {
    super(props);
    this.state = {
			isShow: false,
      showErr: false,
      errorHeight: 0,
			showModal:props.showModal,
      searchFilter: ''
		};
  }
  close = (key) => {
    this.props.handleClose(key);
  }
  // gets outgoing servie list from api
  getServiceList = () => {
    this.setState({
      service: this.props.agentInfo.calling_service_id,
      searchFilter: '',
      loading: this.props.servicesList.length==0,
      showErr: false
    })
    if(this.props.servicesList.length==0){
      this.props.getServicesList().then(() => {
        // logData('Got list');
        this.setState({
          loading: false
        })
      }, (err) => {
        this.setState({
          loading: false,
          showErr: true,
          errorMsg: this.props.translations.commonErrorText[this.props.selectedLanguage],
        });
        logData(err);
      });
    }
  }
  // updates state with selected service
  changeService = (type) => {
    this.setState({service: type});
  }
  // renders list with outgoing service list
  renderList = () => {
    return orderBy(this.props.servicesList, [data => data.name ? data.name.toLowerCase() : ''], ['asc'])
    .filter(service => service.name && service.name.toLowerCase()
    .includes(this.state.searchFilter.toLowerCase()))
    .map(item => {
      return (
        <button
          key={item.id}
          type="button"
          onClick={() => this.changeService(item.id)}
          className={classnames(`list-group-item list-group-item${this.props.theme}`, {active: this.state.service==item.id})}>
          {item.name}
        </button>
      )
    });
  }
  // updates state with search filter value
  handleSearchServiceChange = (e) => {
    this.setState({
      searchFilter: e.target.value
    });
  }
  getErrorHeight = () => {
    const errorHeight = document.getElementById('alertWrapper').clientHeight;
    this.setState({
      errorHeight: errorHeight + 21
    });
  }
  // closes alert
  handleAlertDismiss = () => {
    this.setState({
      showErr: false
    });
  }
  // submit new outgoing service
  handleSubmit = () => {
    const agent_id = localStorage.getItem("agent_id");
    const client_id = localStorage.getItem("clientId");
    if(!this.state.service){
      this.setState({
        showErr: true,
        errorMsg: this.props.translations.selectOutgoingService[this.props.selectedLanguage]
      }, () => {
        this.getErrorHeight();
      });
      return;
    }else{
      const payload = {
        service_id: this.state.service,
      }
      this.props.setDefaultService(payload).then((res) => {
        if(res.data.result==true){
          const agentInfo = this.props.agentInfo;
          agentInfo.calling_service_id = this.state.service;
          let selectedServiceName = ''
          const servicesList = this.props.servicesList
          
          for (const outgoingService of servicesList){
            if (outgoingService.id === this.state.service){
                 selectedServiceName = outgoingService.name;
            }
        }         
          window.mq.send(`/exchange/signal.${client_id}/user.${agent_id}`, {}, `{"tag":"service_change","data" : "${this.state.service}", "name":"${selectedServiceName}"}`);
          this.props.getAgentInfo();
          this.props.handleClose(this.props.showModal);
        }else{
          this.setState({
            showErr: true,
            errorMsg: this.props.translations.commonErrorText[this.props.selectedLanguage]
          }, () => {
            this.getErrorHeight();
          });
        }
      }, (err) => {
        logData(err);
        this.setState({
          showErr: true,
          errorMsg: this.props.translations.commonErrorText[this.props.selectedLanguage]
        }, () => {
          this.getErrorHeight();
        });
      });
    }
  }

  render(){
    const { loading, showErr, errorHeight } = this.state;
    const { translations, selectedLanguage, servicesList } = this.props;
    return (
      <Modal
        onEnter={this.getServiceList}
        show={this.props.showModal}
        onHide={() => this.close('showModal')}
        bsSize="sm"
        backdrop="static"
      >
        <Modal.Header className={`modal-content${this.props.theme} modal-header${this.props.theme}`} closeButton>
          <Modal.Title>{translations.outgoingService[selectedLanguage]}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={`modal-content${this.props.theme}`}>
          {showErr && <div className="alertWrapper" id="alertWrapper"><Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
            <p>{this.state.errorMsg}</p>
          </Alert></div>}
          {(!loading && servicesList.length>0) && <div className="input-with-icon w-full">
          <input
            type="text"
            className={`form-control${this.props.theme} input-smm${this.props.theme}`} 
            placeholder={translations.search[selectedLanguage]}
            style={ {marginBottom: '0.5rem'} }
            onChange={ this.handleSearchServiceChange }
          />
          <span className="icon icon-magnifying-glass" />
          </div>}
          <div className="list-group" style={{maxHeight: showErr ? `calc(345px - ${errorHeight}px)` : 345, overflow: 'auto'}}>
            {loading && <Loader width="20px" height="20px" />}
            {this.renderList()}
            {(!loading && servicesList.length==0) &&
              <h5>{translations.noOutgoingService[selectedLanguage]}</h5>
            }
          </div>
        </Modal.Body>
        <Modal.Footer className={`modal-content${this.props.theme}`}>
          <button
            type="button"
            onClick={() => this.close('showModal')}
            className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`}
            data-dismiss="modal"
            style={ { width: !loading && servicesList.length>0 ? '50%' : '100%' } }
          >
            {translations.cancel[selectedLanguage]}
          </button>
          {(!loading && servicesList.length>0) && <button type="submit" onClick={this.handleSubmit} className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`} data-dismiss="modal">
            <strong>{translations.save[selectedLanguage]}</strong>
          </button>}
        </Modal.Footer>
      </Modal>
    )
  }
}

function mapStateToProps  (state) {
    return {
        agentInfo: state.agentInfo,
        servicesList: state.servicesList,
        translations: state.languages.translations,
				selectedLanguage: state.languages.selectedLanguage,
        darkMode: state.common.darkMode,
        theme: state.common.theme,
    };
}
function mapDispatchToProps (dispatch) {
    return bindActionCreators({getServicesList, setDefaultService, getAgentInfo}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangeOutgoingService);



// WEBPACK FOOTER //
// ./src/agent/modals/changeOutgoingService.js